import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1301Component } from './kymw1301.component';
import { GetPlanCSVService } from './api-services/get-plan-csv.service';
import { GetFeatureThemaListService } from './api-services/get-feature-thema-list.service';


/**
 * 企画書データ出力画面 モジュール設定クラス
 *
 * @export KYMW1301Module
 * @class KYMW1301Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1301Component,
  ],
  providers: [
    GetPlanCSVService,
    GetFeatureThemaListService,
  ],
})
export class KYMW1301Module {
}
